import React from 'react';
import withIcon from '../utilities/withIcon';

const IconNumber9 = () => {
  return (
    <g>
      <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM7.94 3.897a2.562 2.562 0 0 0-2.72 2.66 2.36 2.36 0 0 0 2.279 2.51l.182-.002a2.036 2.036 0 0 0 1.89-1.148l.064-.147h.036v.2c0 1.66-.707 2.908-1.979 2.908a1.45 1.45 0 0 1-1.364-.873l-.048-.128-1.036.683a2.457 2.457 0 0 0 2.253 1.49l.184-.007c1.995 0 3.262-1.646 3.339-4.04l.004-.233a4.664 4.664 0 0 0-.695-2.625 2.72 2.72 0 0 0-2.39-1.248zm.059 1.153a1.36 1.36 0 0 1 1.4 1.448 1.36 1.36 0 0 1-1.4 1.449A1.37 1.37 0 0 1 6.56 6.643v-.145A1.37 1.37 0 0 1 7.999 5.05z" />
    </g>
  );
};

export default withIcon(IconNumber9);
